import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { ThemeColorsKeys } from '../../styles/tokens/colors';
import { Cross } from '../icon';

// Interface

export interface ExclusionListProps {
  items: string[];
}

// Styles

const StyledExclusionList = styled.ul`
  ${({ theme: { space, colors, media } }) => css`
    display: grid;
    row-gap: ${space.small};

    li {
      display: flex;
      align-items: center;
      gap: ${space.xxSmall};

      &:not(:last-of-type) {
        padding-bottom: ${space.small};
        border-bottom: solid 1px ${colors.darkBlue};
      }
    }

    @media (min-width: ${media.large}) {
      grid-template-columns: repeat(2, 1fr);
      column-gap: ${space.medium};
    }
  `};
`;

// JSX

export const ExclusionList: FC<ExclusionListProps> = ({ items }) => (
  <StyledExclusionList>
    {items?.map((item, index) => (
      <li key={index}>
        <Cross color="red" />
        {item}
      </li>
    ))}
  </StyledExclusionList>
);

export default ExclusionList;
